import { ServerActionWidget, SPI, BaseActionWidget, ActionType, ClickResult, ViewType, DialogViewActionWidget } from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';
import { Modal } from 'ant-design-vue';
import { createVNode } from 'vue';
import LogisticsTrackComp from './LogisticsTrack.vue';
import { queryLogisticsTrackV2 } from './services';

@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.View,
    model: 'deli.aries.seller.SellerDistributorTmsOrder',
    name: 'uiView4c8ef0fb997041d6939c924cd8f295c2',
    widget: 'ViewAction'
  })
)
@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.View,
    model: 'deli.aries.logistics.DeliAriesPlatformBrandStoreTmsOrder',
    name: 'uiViewab4da5dbef0f4d3c95b0115f7cafdc49',
    widget: 'ViewAction'
  })
)
@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.View,
    model: 'aries.logistics.DeliAriesBuyerTmsOrder',
    name: 'uiViewc9a3116d58b64f73a2e197b84c356a21',
    widget: 'ViewAction'
  })
)
export class LogisticsTrackActionWidget extends DialogViewActionWidget {
  protected async clickAction() {
    const activeRecord = this.activeRecords?.[0];
    if (!activeRecord?.id) {
      OioNotification.warning('提示', '请先选择一条记录');
      return;
    }

    try {
      const model = this.model.model;
      const data = await queryLogisticsTrackV2(model, this.model.moduleName, activeRecord.id as any);

      if (!data || !data.trackList || data.trackList.length === 0) {
        OioNotification.info('提示', '暂无物流轨迹');
        return;
      }

      Modal.info({
        title: '物流轨迹',
        width: 640,
        content: createVNode(LogisticsTrackComp, { trackData: data }),
        okText: '关闭',
        icon: null,
        centered: true
      });
    } catch (e) {
      console.error('查询物流轨迹失败', e);
      OioNotification.error('错误', '查询物流轨迹失败');
    }
  }
}
